export default "__VITE_ASSET__reJLtXS7__"